<template>
	<el-dialog :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false"
		:title="(type?'修改':'添加')+'人员'" :visible.sync="value" width="40%">
		<el-form label-position="right" label-width="120px" size="small" ref="form" :model="form">
			<el-form-item label="管理人">
				<el-input class="maxwidth" v-model="form.name"></el-input>
			</el-form-item>
			<el-form-item label="身份证号">
				<el-input class="maxwidth" v-model="form.idcard"></el-input>
			</el-form-item>
			<el-form-item label="手机号">
				<el-input class="maxwidth" v-model="form.phone"></el-input>
			</el-form-item>
			<el-form-item v-if="!form.uid" label="初始密码">
				<el-input class="maxwidth" v-model="form.password"></el-input>
			</el-form-item>
			<el-form-item label="所属单位">
				<el-select @change="changeDW" class="maxwidth" v-model="form.org_id" placeholder="请选择">
					<el-option v-for="item in options" :key="item.org_id" :label="item.name" :value="item.org_id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="业务办理权限">
				<el-select multiple class="maxwidth" v-model="form.role" placeholder="请选择">
					<el-option v-for="item in types" :key="item.name" :label="item.name" :value="item.name">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="管理员权限">
				<el-switch v-model="form.allow_manage" active-text="开启" inactive-text="关闭">
				</el-switch>
			</el-form-item>
			<el-form-item label="短信提示">
				<el-switch v-model="form.sms_tixing" active-text="开启" inactive-text="关闭">
				</el-switch>
			</el-form-item>

		</el-form>
		<span slot="footer" class="dialog-footer">
			<el-button @click="handleClose()">取 消</el-button>
			<el-button @click="add" type="primary">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
	import sm from "sm-crypto";
	export default {
		data() {
			return {
				dialogVisible: false,
				form: {
					name: "",
					org_id: "",
					idcard: "",
					password: "123456",
					phone: "",
					role: [],
					allow_manage: false,
					sms_tixing: false
				},
				options: [],
				types: []
			}

		},

		computed: {
			org() {
				let org = window.localStorage.getItem("org");
				return JSON.parse(org);
			},
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			}
		},
		props: ["value", "type", "shuju"],
		methods: {

			changeDW(e) {
				let pian = this.options.find(p => p.org_id == e);
				if (pian.roles.length > 0 && pian.roles[0] != "all") {
					let newp = [];
					pian.roles.map(p => {
						newp.push({
							name: p
						});
					});
					this.types = newp;
				} else {
					this.gettypes();
				};
			},
			async init(shuju) {
				this.form = shuju;
			},
			async add() {
				this.form.token = this.info.uid;
				let form = JSON.parse(JSON.stringify(this.form));
				if (form.password) {
					form.password = sm.sm2.doEncrypt(form.password,
						"02a9fa092d95434eea7998ee6fa25a0abeda98496575685063608815fd9da1eb5c", 1);
				}

				let ans = await axios.post(this.$url + "admin/addman", this.form);
				if (ans.data.status == 0) {
					this.$message({
						message: ans.data.desc,
						type: 'success'
					});
					this.$emit("input", false);
					this.$parent.getdata();
				} else {
					this.$message({
						message: ans.data.desc,
						type: 'error'
					});
				}
			},
			handleClose() {
				this.$emit("input", false);
			},
			async getarea() {
				let ans = await axios.get(this.$url + "admin/orgs", {
					params: {
						token: this.info.uid,
						id: this.org.org_id,
					}
				});
				this.options = ans.data.lists;
			},
			async gettypes() {
				let ans = await axios.get(this.$url + "admin/types", {
					params: {
						token: this.info.uid
					}
				});
				this.types = ans.data;

			},
		},
		created() {
			this.getarea();
			this.gettypes();
		}
	}
</script>

<style>
	.maxwidth {
		max-width: 250px
	}
</style>